import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import "antd/es/form/style";
import _Form from "antd/es/form";
var _excluded = ["children", "value", "onChange", "onBlur", "valuePropName"],
    _excluded2 = ["children", "addonAfter", "addonBefore"],
    _excluded3 = ["valueType", "transform", "dataFormat", "ignoreFormItem", "lightProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useEffect, useMemo } from 'react';
import { FormListContext } from '../List';
import FieldContext from '../../FieldContext';
import { isDropdownValueType, omitUndefined } from '@ant-design/pro-utils';
import LightWrapper from '../../BaseForm/LightWrapper';
/**
 * 把value扔给 fieldProps，方便给自定义用
 *
 * @param param0
 * @returns
 */

var WithValueFomFiledProps = function WithValueFomFiledProps(formFieldProps) {
  var filedChildren = formFieldProps.children,
      value = formFieldProps.value,
      _onChange = formFieldProps.onChange,
      _onBlur = formFieldProps.onBlur,
      _formFieldProps$value = formFieldProps.valuePropName,
      valuePropName = _formFieldProps$value === void 0 ? 'value' : _formFieldProps$value,
      restProps = _objectWithoutProperties(formFieldProps, _excluded);

  var fieldProps = useMemo(function () {
    var _filedChildren$type, _filedChildren$props;

    // @ts-ignore
    if ((filedChildren === null || filedChildren === void 0 ? void 0 : (_filedChildren$type = filedChildren.type) === null || _filedChildren$type === void 0 ? void 0 : _filedChildren$type.displayName) !== 'ProFormComponent') return undefined;
    if (! /*#__PURE__*/React.isValidElement(filedChildren)) return undefined;
    return omitUndefined(_objectSpread(_objectSpread(_defineProperty({
      id: restProps.id
    }, valuePropName, formFieldProps[valuePropName]), (filedChildren === null || filedChildren === void 0 ? void 0 : (_filedChildren$props = filedChildren.props) === null || _filedChildren$props === void 0 ? void 0 : _filedChildren$props.fieldProps) || {}), {}, {
      onBlur: function onBlur() {
        var _filedChildren$props2, _filedChildren$props3, _filedChildren$props4, _filedChildren$props5, _filedChildren$props6;

        for (var _len = arguments.length, restParams = new Array(_len), _key = 0; _key < _len; _key++) {
          restParams[_key] = arguments[_key];
        }

        _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur.apply(void 0, restParams);
        filedChildren === null || filedChildren === void 0 ? void 0 : (_filedChildren$props2 = filedChildren.props) === null || _filedChildren$props2 === void 0 ? void 0 : (_filedChildren$props3 = _filedChildren$props2.onBlur) === null || _filedChildren$props3 === void 0 ? void 0 : _filedChildren$props3.call.apply(_filedChildren$props3, [_filedChildren$props2].concat(restParams));
        filedChildren === null || filedChildren === void 0 ? void 0 : (_filedChildren$props4 = filedChildren.props) === null || _filedChildren$props4 === void 0 ? void 0 : (_filedChildren$props5 = _filedChildren$props4.fieldProps) === null || _filedChildren$props5 === void 0 ? void 0 : (_filedChildren$props6 = _filedChildren$props5.onBlur) === null || _filedChildren$props6 === void 0 ? void 0 : _filedChildren$props6.call.apply(_filedChildren$props6, [_filedChildren$props5].concat(restParams));
      },
      // 这个 onChange 是 Form.Item 添加上的，
      // 要通过 fieldProps 透传给 ProField 调用
      onChange: function onChange() {
        var _filedChildren$props7, _filedChildren$props8, _filedChildren$props9, _filedChildren$props10, _filedChildren$props11;

        for (var _len2 = arguments.length, restParams = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          restParams[_key2] = arguments[_key2];
        }

        _onChange === null || _onChange === void 0 ? void 0 : _onChange.apply(void 0, restParams);
        filedChildren === null || filedChildren === void 0 ? void 0 : (_filedChildren$props7 = filedChildren.props) === null || _filedChildren$props7 === void 0 ? void 0 : (_filedChildren$props8 = _filedChildren$props7.onChange) === null || _filedChildren$props8 === void 0 ? void 0 : _filedChildren$props8.call.apply(_filedChildren$props8, [_filedChildren$props7].concat(restParams));
        filedChildren === null || filedChildren === void 0 ? void 0 : (_filedChildren$props9 = filedChildren.props) === null || _filedChildren$props9 === void 0 ? void 0 : (_filedChildren$props10 = _filedChildren$props9.fieldProps) === null || _filedChildren$props10 === void 0 ? void 0 : (_filedChildren$props11 = _filedChildren$props10.onChange) === null || _filedChildren$props11 === void 0 ? void 0 : _filedChildren$props11.call.apply(_filedChildren$props11, [_filedChildren$props10].concat(restParams));
      }
    }));
  }, [filedChildren, formFieldProps, _onBlur, _onChange, restProps.id, valuePropName]);
  if (! /*#__PURE__*/React.isValidElement(filedChildren)) return filedChildren;
  return /*#__PURE__*/React.cloneElement(filedChildren, omitUndefined(_objectSpread(_objectSpread(_objectSpread({}, restProps), {}, {
    value: value
  }, filedChildren.props), {}, {
    onChange: function onChange() {
      var _filedChildren$props12, _filedChildren$props13;

      for (var _len3 = arguments.length, restParams = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        restParams[_key3] = arguments[_key3];
      }

      _onChange === null || _onChange === void 0 ? void 0 : _onChange.apply(void 0, restParams);
      filedChildren === null || filedChildren === void 0 ? void 0 : (_filedChildren$props12 = filedChildren.props) === null || _filedChildren$props12 === void 0 ? void 0 : (_filedChildren$props13 = _filedChildren$props12.onChange) === null || _filedChildren$props13 === void 0 ? void 0 : _filedChildren$props13.call.apply(_filedChildren$props13, [_filedChildren$props12].concat(restParams));
    },
    fieldProps: fieldProps
  })));
};
/**
 * 支持了一下前置 dom 和后置的 dom
 *
 * @param WarpFormItemProps
 * @returns
 */


var WarpFormItem = function WarpFormItem(_ref) {
  var children = _ref.children,
      addonAfter = _ref.addonAfter,
      addonBefore = _ref.addonBefore,
      props = _objectWithoutProperties(_ref, _excluded2);

  if (!addonAfter && !addonBefore) return /*#__PURE__*/React.createElement(_Form.Item, props, children);
  return /*#__PURE__*/React.createElement(_Form.Item, props, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, addonBefore ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: 8
    }
  }, addonBefore) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(_Form.Item, _extends({}, props, {
    noStyle: true
  }), children)), addonAfter ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 8
    }
  }, addonAfter) : null));
};

var ProFormItem = function ProFormItem(props) {
  var _rest$name, _rest$name2;

  var size = useContext(_ConfigProvider.SizeContext);

  var valueType = props.valueType,
      transform = props.transform,
      dataFormat = props.dataFormat,
      ignoreFormItem = props.ignoreFormItem,
      _props$lightProps = props.lightProps,
      lightProps = _props$lightProps === void 0 ? {} : _props$lightProps,
      rest = _objectWithoutProperties(props, _excluded3);

  var formListField = useContext(FormListContext); // ProFromList 的 filed，里面有name和key

  /** 从 context 中拿到的值 */

  var name = useMemo(function () {
    if (formListField.name !== undefined) {
      return [formListField.name, props.name].flat(1);
    }

    return props.name;
  }, [formListField.name, props.name]);
  /** 从 context 中拿到的值 */

  var _React$useContext = React.useContext(FieldContext),
      setFieldValueType = _React$useContext.setFieldValueType;

  useEffect(function () {
    // 如果 setFieldValueType 和 props.name 不存在不存入
    if (!setFieldValueType || !props.name) {
      return;
    } // Field.type === 'ProField' 时 props 里面是有 valueType 的，所以要设置一下
    // 写一个 ts 比较麻烦，用 any 顶一下


    setFieldValueType([formListField.listName, name].flat(1).filter(function (itemName) {
      return itemName !== undefined;
    }), {
      valueType: valueType || 'text',
      dateFormat: dataFormat,
      transform: transform
    });
  }, [formListField.listName, name, dataFormat, props.name, setFieldValueType, transform, valueType]);
  var isDropdown = /*#__PURE__*/React.isValidElement(props.children) && isDropdownValueType(valueType || props.children.props.valueType);
  var noLightFormItem = useMemo(function () {
    if (!lightProps.light || lightProps.customLightMode || isDropdown) {
      return true;
    }

    return false;
  }, [lightProps.customLightMode, isDropdown, lightProps.light]);

  if (typeof props.children === 'function') {
    return /*#__PURE__*/React.createElement(WarpFormItem, _extends({}, rest, {
      name: name
    }), props.children);
  } // formItem 支持function，如果是function 我就直接不管了


  var children = /*#__PURE__*/React.createElement(WithValueFomFiledProps, {
    key: (_rest$name = rest.name) === null || _rest$name === void 0 ? void 0 : _rest$name.toString(),
    valuePropName: props.valuePropName
  }, props.children);
  var lightDom = noLightFormItem ? children : /*#__PURE__*/React.createElement(LightWrapper, _extends({}, lightProps, {
    key: (_rest$name2 = rest.name) === null || _rest$name2 === void 0 ? void 0 : _rest$name2.toString(),
    size: size
  }), children); // 这里控制是否需要 LightWrapper，为了提升一点点性能

  if (ignoreFormItem) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, lightDom);
  }

  return /*#__PURE__*/React.createElement(WarpFormItem, _extends({}, rest, {
    name: name
  }), lightDom);
};

export default ProFormItem;